import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

export const useMeVendors = (): UseQueryResult<UserVendor[]> => {
  const { getUserVendors } = useVendorsApiClient()
  return useQuery<UserVendor[]>({
    queryKey: ['vendors-me'],
    queryFn: () => getUserVendors(),
    refetchOnWindowFocus: false
  })
}

export const useVendorUsersOpenRequestForProposals = (): UseQueryResult<VendorUserRequestForProposal[]> => {
  const { getOpenRequestForProposals } = useVendorsApiClient()

  return useQuery<VendorUserRequestForProposal[]>({
    queryKey: ['vendor-user-rfps'],
    queryFn: () => getOpenRequestForProposals(),
    refetchOnWindowFocus: false
  })
}

export const useVendorUsersReguestForProposalsAvailableToModify = (): UseQueryResult<
  AvailableToModifyRequestForProposals[]
> => {
  const { getAvailableToModifyRequestForProposals } = useVendorsApiClient()

  return useQuery<AvailableToModifyRequestForProposals[]>({
    queryKey: ['vendor-user-rfps-available-modify'],
    queryFn: () => getAvailableToModifyRequestForProposals(),
    refetchOnWindowFocus: false
  })
}

export const useVendorUserProposalsHistory = (): UseQueryResult<ProposalHistory[]> => {
  const { getUserProposalsHistory } = useVendorsApiClient()

  return useQuery<ProposalHistory[]>({
    queryKey: ['vendor-user-proposal-history'],
    queryFn: () => getUserProposalsHistory(),
    refetchOnWindowFocus: false
  })
}
